import { combineEpics } from "redux-observable";
import { epicSoundsBuildingCelebration } from "./epics/epicSoundsBuildingCelebration";
import { epicSoundsBuildingFinishMove } from "./epics/epicSoundsBuildingFinishMove";
import { epicSoundsBuildingProductionFinish } from "./epics/epicSoundsBuildingProductionFinish";
import { epicSoundsBuildingProductionStart } from "./epics/epicSoundsBuildingProductionStart";
import { epicSoundsBuildingRotate } from "./epics/epicSoundsBuildingRotate";
import { epicSoundsBuildingStartMove } from "./epics/epicSoundsBuildingStartMove";
import { epicSoundsLevelUp } from "./epics/epicSoundsLevelUp";
import { epicSoundsMarketContractTrash } from "./epics/epicSoundsMarketContractTrash";
import { epicSoundsMusic } from "./epics/epicSoundsMusic";
import { epicSoundsPelletDrop } from "./epics/epicSoundsPelletDrop";
import { epicSoundsQuestComplete } from "./epics/epicSoundsQuestComplete";
import { epicSoundsRestoreSettings } from "./epics/epicSoundsRestoreSettings";
import { epicSoundsSpendGold } from "./epics/epicSoundsSpendGold";
import { epicSoundsTradeSell } from "./epics/epicSoundsTradeSell";
export var epicSounds = combineEpics(epicSoundsRestoreSettings, epicSoundsMusic, epicSoundsBuildingCelebration, epicSoundsBuildingFinishMove, epicSoundsBuildingStartMove, epicSoundsBuildingRotate, epicSoundsBuildingProductionFinish, epicSoundsBuildingProductionStart, epicSoundsMarketContractTrash, epicSoundsQuestComplete, epicSoundsLevelUp, epicSoundsTradeSell, epicSoundsSpendGold, epicSoundsPelletDrop);



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epicSounds.ts
// module id = 2399
// module chunks = 3